"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function createStore(userReducer, initState, localStorageKey) {
    var dispathContext = react_1.default.createContext(function (value) { });
    var storeContext = react_1.default.createContext(initState);
    if (localStorageKey) {
        try {
            initState = JSON.parse(window.localStorage.getItem(localStorageKey) || '') || initState;
        }
        catch (_a) { }
    }
    var reducer = function (state, action) {
        var newState = userReducer(state, action);
        if (localStorageKey) {
            localStorage.setItem(localStorageKey, JSON.stringify(newState));
        }
        return newState;
    };
    var StoreProvider = function (_a) {
        var children = _a.children;
        var _b = react_1.default.useReducer(reducer, initState), store = _b[0], dispatch = _b[1];
        return (react_1.default.createElement(dispathContext.Provider, { value: dispatch },
            react_1.default.createElement(storeContext.Provider, { value: store }, children)));
    };
    function useDispatch() {
        return react_1.default.useContext(dispathContext);
    }
    function useStore() {
        return react_1.default.useContext(storeContext);
    }
    return [StoreProvider, useDispatch, useStore];
}
exports.default = createStore;
//# sourceMappingURL=index.js.map